// @flow

import * as React from 'react';
import Col from 'react-aaui/lib/grid/Col';

const ResultsCol = ({ children, ...props }: Object) => (
  <Col {...props} responsiveTiers={{ xl: 'col-xl' }}>
    {children}
  </Col>
);

export default ResultsCol;
